import './primitives.css';

export interface SpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  label?: string;
  decorative?: boolean;
  className?: string;
}

const TICK_COUNT = 12;
const ticks = Array.from({ length: TICK_COUNT }, (_, i) => (
  <span
    key={i}
    className="lm-spinner__tick"
    style={{ transform: `rotate(${i * 30}deg)`, opacity: 0.12 + (i / (TICK_COUNT - 1)) * 0.88 }}
  />
));

export function Spinner({ size = 'md', label = 'Loading', decorative = false, className }: SpinnerProps) {
  const classes = ['lm-spinner', size !== 'md' ? `lm-spinner--${size}` : '', className]
    .filter(Boolean)
    .join(' ');
  return decorative
    ? <span className={classes} aria-hidden="true">{ticks}</span>
    : <span className={classes} role="status" aria-label={label}>{ticks}</span>;
}

export interface QuietStatusProps {
  title?: string;
  detail?: string;
  size?: SpinnerProps['size'];
  inline?: boolean;
  className?: string;
}

export function QuietStatus({
  title = 'Loading',
  detail,
  size = 'md',
  inline = false,
  className,
}: QuietStatusProps) {
  const classes = ['lm-quiet-status', inline ? 'lm-quiet-status--inline' : '', className]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={classes} role="status" aria-label={detail ? `${title}. ${detail}` : title}>
      <Spinner size={size} label={title} decorative />
      <span className="lm-quiet-status__copy">
        <strong>{title}</strong>
        {detail && <span>{detail}</span>}
      </span>
    </div>
  );
}
